import * as CryptoJS from 'crypto-js';
import { secretKey } from './urls'

export let encryptValue = (toEncrypt: any) => {
    return CryptoJS.AES.encrypt(toEncrypt, secretKey).toString()
}

export let decryptValue = (toDecrypt: any) => {
    return CryptoJS.AES.decrypt(toDecrypt, secretKey).toString(CryptoJS.enc.Utf8)
}